module.exports = __webpack_public_path__ + "img/philipe.bd1f4872.png";